import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThresholdService {
  private timeout: NodeJS.Timeout | undefined;
  private timeoutDuration: number = 500; // in ms

  constructor() { }

  public async withThreshold<T>(
    callBack: () => T,
    duration?: number,
    disabledThreshold?: boolean,
  ) {
    if (disabledThreshold) {
      await callBack();
      return;
    }

    if (this.timeout) {
      this.clearTimeout();
    }
    this.timeout = setTimeout(callBack, duration ?? this.timeoutDuration);
  }

  private clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = undefined;
    }
  }
}
